/* eslint-disable no-new-func */
import { useEffect } from "react";
import Constants from "common/constant";
import { sleep, usePlaySound } from "common/utils";
import { AnswerMark } from "features/courses/program/game/components";
import { RuntimePropType } from "features/courses/program/game/stages/types";

export const Runtime = (props: RuntimePropType) => {
  const sound = usePlaySound(
    `${Constants.assetHost}/assets/blockly/itemget.mp3`
  );
  const { event, highlightBlock, setSuccess, setGameOver } = props;
  const handleEvent = new Function(
    "sleep",
    "sound",
    "highlightBlock",
    "setSuccess",
    "setGameOver",
    event[0]
      ? event[0]
      : `return () => {
          setSuccess(false);
          setGameOver(true);
        }
        `
  );
  useEffect(() => {
    const loading = setTimeout(() => {
      handleEvent(sleep, sound, highlightBlock, setSuccess, setGameOver)();
    }, 300);
    return () => {
      clearTimeout(loading);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="flex-row-view flex-center w-full gap-2">
      <div
        id="course-program-border-1"
        className="flex-col-center p-2 border-solid border-[2px] rounded-[20px] border-white/20"
      >
        <img
          alt="*"
          src={`${Constants.assetHost}/stamps/food/1a0dfd95f4e66ae82b697271462f8cff.png`}
          className="w-[100px] h-[100px] opacity-40 absolute"
          style={{
            filter: "drop-shadow(0px 1px 3px rgba(255, 255, 255, 1))",
          }}
        />
        <img
          alt="*"
          id="course-program-image-1"
          className="w-[100px] h-[100px] opacity-0 z-10 transition duration-700 scale-150"
        />
        <AnswerMark id={1} />
      </div>
      <p
        id="course-program-arrow-1"
        className="text text-white !text-[30px] opacity-0"
      >
        ▶︎
      </p>
      <div
        id="course-program-border-2"
        className="flex-col-center p-2 border-solid border-[2px] rounded-[20px] border-white/20"
      >
        <img
          alt="*"
          src={`${Constants.assetHost}/stamps/food/b1d06bd0cb252619058dce3b50eb3a1f.png`}
          className="w-[100px] h-[100px] opacity-40 absolute"
          style={{
            filter: "drop-shadow(0px 1px 3px rgba(255, 255, 255, 1))",
          }}
        />
        <img
          alt="*"
          id="course-program-image-2"
          className="w-[100px] h-[100px] opacity-0 z-10 transition duration-700 scale-150"
        />
        <AnswerMark id={2} />
      </div>
      <p
        id="course-program-arrow-2"
        className="text text-white !text-[30px] opacity-0"
      >
        ▶︎
      </p>
      <div
        id="course-program-border-3"
        className="flex-col-center p-2 border-solid border-[2px] rounded-[20px] border-white/20"
      >
        <img
          alt="*"
          src={`${Constants.assetHost}/stamps/food/f0441f75aa862c94ed0c484b3911bd1c.png`}
          className="w-[100px] h-[100px] opacity-40 absolute"
          style={{
            filter: "drop-shadow(0px 1px 3px rgba(255, 255, 255, 1))",
          }}
        />
        <img
          alt="*"
          id="course-program-image-3"
          className="w-[100px] h-[100px] opacity-0 z-10 transition duration-700 scale-150"
        />
        <AnswerMark id={3} />
      </div>
    </div>
  );
};
